import type { HbBidderConfig } from '../types'

const DISPLAY_PLACEMENT_ID = 91948
const VIDEO_PLACEMENT_ID = 91949

export const ADITUDE_DISPLAY: HbBidderConfig = {
    bidder: 'cpmstar',
    params: {
        placementId: DISPLAY_PLACEMENT_ID,
    },
}

export const ADITUDE_VIDEO: HbBidderConfig = {
    bidder: 'cpmstar',
    params: {
        placementId: VIDEO_PLACEMENT_ID,
    },
}
